export default {
    BusinessPurchaseCostDown: {
        number: 'Contract number',
        BasePrice: 'Base Price',
        price: 'Purchase unit price',
        amount: 'Purchase amount',
        Cost: 'Cost reduction amount',
        time: 'Purchase time',
        statistics: 'Cost statistics or not',
        Total: 'Total cost reduction amount',
        Base: 'Base Date',
        Calculate: 'Calculate Date',
        The: 'The Base Date cannot be greater than or equal to the Calculate Date !',
        purchaser: 'Purchaser',
        Assessment: 'Assessment month',
        SKUs: 'Total number of SKUs',
        ignored: 'SKU quantity ignored',
        notIgnored: 'SKU quantity not ignored',
        Aquantity: 'LevelA quantity',
        Bquantity: 'LevelB quantity',
        completedA: 'LevelA completed quantity',
        completedB: 'LevelB completed quantity',
        ERPA: 'Completed quantity of LevelA ERP',
        ERPB: 'Completed quantity of LevelB ERP',
        TimelinessA: 'Timeliness rate of LevelA return orders',
        TimelinessB: 'Timeliness rate of LevelB return orders',
        TimelinessERPA: 'Timeliness rate of LevelB ERP return orders',
        TimelinessERPB: 'Timeliness rate of LevelB ERP return orders',
        Timeliness: 'Timeliness rate of overall return orders',
        TimelinessERP: 'Timeliness rate of overall ERP return orders',
        exportDetail: 'Export Details'
    }
  };
